var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { GalaxyApi } from "@/api";
export const useConfigStore = defineStore("configurationStore", () => {
    const config = ref(null);
    const isLoading = ref(false);
    const isLoaded = computed(() => !!config.value);
    function loadConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isLoaded.value && !isLoading.value) {
                isLoading.value = true;
                try {
                    const { data, error } = yield GalaxyApi().GET("/api/configuration");
                    if (error) {
                        console.error("Error loading Galaxy configuration", error);
                    }
                    config.value = data;
                    console.debug("Galaxy configuration loaded", config.value);
                }
                finally {
                    isLoading.value = false;
                }
            }
        });
    }
    function setConfiguration(configuration) {
        config.value = configuration;
    }
    loadConfig();
    return {
        config,
        isLoaded,
        loadConfig,
        setConfiguration,
    };
});
